import { Injectable } from '@angular/core';
import { CmsPage } from '@kion/data-models';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ProductsFacade } from '@kion/data-access/data-access-products';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private metaService: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private productsFacade: ProductsFacade
  ) { }

  setMetadata(cmsPage: CmsPage, subSink: SubSink): void {
    if(cmsPage) {
      this.titleService.setTitle(cmsPage.title);
      this.metaService.updateTag({name: 'description', content: cmsPage.metaDescription});
      if (cmsPage?.index) {
        this.metaService.updateTag({
          name: 'robots',
          content: (  cmsPage?.index?.replace('_', '') +
            ',' +
            cmsPage?.follow?.replace('_', ''))
            .toLowerCase()
        });
      } else {
        this.metaService.updateTag({
          name: 'robots',
          content: "index, follow"
        });
      }
    }
    subSink.sink = combineLatest(
      [
        this.productsFacade.all$,
        this.productsFacade.activeProductId$
      ]
    ).pipe(
      map(
        ([ products, productId ]) => products.find(
          product => product.id === productId
        )
      )
    ).subscribe(
      (product) => {
        if (product) {
          this.titleService.setTitle(product.pageTitle || product.name);
          this.metaService.updateTag({name: 'description', content: product.metaData || product.name});
        }
      }
    )
  }
}
